import { ADD_SURVEY_URL_FAIL, ADD_SURVEY_URL_REQUEST, ADD_SURVEY_URL_SUCCESS, DELETE_SURVEY_URL_FAIL, DELETE_SURVEY_URL_REQUEST, DELETE_SURVEY_URL_SUCCESS, GET_SURVEY_URL_FAIL, GET_SURVEY_URL_REQUEST, GET_SURVEY_URL_SUCCESS, UPDATE_SURVEY_URL_FAIL, UPDATE_SURVEY_URL_REQUEST, UPDATE_SURVEY_URL_STATUS_FAIL, UPDATE_SURVEY_URL_STATUS_REQUEST, UPDATE_SURVEY_URL_STATUS_SUCCESS, UPDATE_SURVEY_URL_SUCCESS } from "../constant"

const initialState = {
  surveyUrlData: [],

  getSurveyUrlDataLoading: false
}

const urlReducer = (state = initialState, action) => {
  switch (action.type) {

    //Get Survey URL
    case GET_SURVEY_URL_REQUEST:
      return {
        ...state,
        surveyUrlData: [],
        getSurveyUrlDataLoading: true
      }
    case GET_SURVEY_URL_SUCCESS:
      return {
        ...state,
        surveyUrlData: action.payload,
        getSurveyUrlDataLoading: false
      }
    case GET_SURVEY_URL_FAIL:
      return {
        ...state,
        surveyUrlData: [],
        getSurveyUrlDataLoading: false
      }

    //Add Survey URL
    case ADD_SURVEY_URL_REQUEST:
      return {
        ...state,
      }
    case ADD_SURVEY_URL_SUCCESS:
      return {
        ...state,
      }
    case ADD_SURVEY_URL_FAIL:
      return {
        ...state,
      }

    //Update Survey URL
    case UPDATE_SURVEY_URL_REQUEST:
      return {
        ...state,
      }
    case UPDATE_SURVEY_URL_SUCCESS:
      return {
        ...state,
      }
    case UPDATE_SURVEY_URL_FAIL:
      return {
        ...state,
      }

    //Delete Survey URL
    case DELETE_SURVEY_URL_REQUEST:
      return {
        ...state,
      }
    case DELETE_SURVEY_URL_SUCCESS:
      let data = state?.surveyUrlData?.filter((link) => link.survey_link_id !== action.payload)
      return {
        ...state,
        surveyUrlData: [...data]
      }

    case DELETE_SURVEY_URL_FAIL:
      return {
        ...state,
      }

    //Update URL Status
    case UPDATE_SURVEY_URL_STATUS_REQUEST:
      return {
        ...state,
      }
    case UPDATE_SURVEY_URL_STATUS_SUCCESS:
      let updatedDataStatus = state?.surveyUrlData?.map((link) => {
        if (Number(link.survey_link_id) === Number(action.payload.survey_link_id)) {
          return { ...link, is_active: action.payload.status }
        }
        return link
      })
      return {
        ...state,
        surveyUrlData: [...updatedDataStatus]
      }
    case UPDATE_SURVEY_URL_STATUS_FAIL:
      return {
        ...state,
      }

    //Default
    default:
      return state;
  }
}

export { urlReducer }